module.exports = __webpack_public_path__ + "media/react/assets/iQmetrix-04f3b749294bc1ac56b612a89d357a88.png";